module.exports = __webpack_public_path__ + "static/media/28.10c84f64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/dessins_cafe/28.jpg
// module id = 623
// module chunks = 0